import React,{Component} from 'react';
import {UISref} from 'ui-router-react'; 
import {createMarkup} from './Factory';

class Search extends Component {
	componentWillMount(){
		document.body.classList.remove('no-scroll');
	}
	render(){		
		const {result} = this.props;
		return(
				<div>
				{
					result.map( (data,i)=>{
						let { post_title,post_name,post_content,post_excerpt,label,state } = data;
						if(post_excerpt===''){
							post_excerpt = post_content.substr(0,250);
						}
						return (
							<UISref to={state} params={{item:post_name}}  key={i}>
								<a className="search-results-item md-txt" to={state}>
									<b dangerouslySetInnerHTML={createMarkup(label+" : "+post_title)}></b>
									<p dangerouslySetInnerHTML={createMarkup(post_excerpt)}></p>
								</a>
							</UISref>
						)
					})
				}
				</div>
		)
	}
}
export default Search; 




// WEBPACK FOOTER //
// ./src/components/Search.js